export default "__VITE_ASSET__BzGT$F6E__"